import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Alert } from '@ui'
import { useLocation } from 'react-router-dom'

import { SideNav } from '../components/sideNav'
import { MerchantSelector } from '../components/merchantSelector/MerchantSelector'
import cssVariables from '../styles/cssVariables'
import { smallerThan, biggerThan } from '../styles'
import { useGoogleAnalytics } from '../components'
import { getCurrentMerchantID } from '../features/data'

const Wrapper = styled.div`
	margin-left: 72px;
	min-height: 100vh;
	padding: 0 20px;

	${biggerThan.tablet`
		margin-left: 228px;
	`}

	${smallerThan.tablet`
		margin-left: 56px;
		padding: 0 14px;
	`}
`
const AppContent = styled.div`
	max-width: 984px;
	width: 100%;
	margin: 0 auto;
	padding-top: 42px;
`

const StyledMerchantSelector = styled(MerchantSelector)`
	position: absolute;
	top: ${cssVariables.spacings.default};
	right: ${cssVariables.spacings.xxxl};

	${smallerThan.desktop`
		right: ${cssVariables.spacings.xxl};
	`}

	${smallerThan.tablet`
		right: ${cssVariables.spacings.xl};
	`}

	${smallerThan.phone`
		right: 14px;
		width: min(calc(100% - 84px), 360px);
	`}
`

const AppLayout = ({ children }) => {
	const [isSideNavOpen, toggleSideNav] = useState(false)
	const { currentMerchantID } = getCurrentMerchantID()
	useGoogleAnalytics()
	const { pathname } = useLocation()

	const onSystemSettingsPage = pathname.includes('/system-settings')
	const onUserAccountPage = pathname.includes('/user-account')
	const onFinnacePage = pathname.includes('/finance')
	const onAdvancedSettingsPage = pathname.includes('/advanced-settings')
	const canRenderWithoutMerchant =
		onSystemSettingsPage || onUserAccountPage || onFinnacePage || onAdvancedSettingsPage
	return (
		<main>
			<SideNav {...{ isSideNavOpen }} toggleSideNavOverlay={() => toggleSideNav(!isSideNavOpen)} isDesktopMenu />
			<Wrapper>
				{!currentMerchantID && !canRenderWithoutMerchant && (
					<AppContent>
						<Alert primary>Please select a merchant from the dropdown in the top right of the page.</Alert>
					</AppContent>
				)}
				{(currentMerchantID || canRenderWithoutMerchant) && <AppContent>{children}</AppContent>}
			</Wrapper>
			{!onSystemSettingsPage && <StyledMerchantSelector />}
		</main>
	)
}

AppLayout.propTypes = {
	children: PropTypes.any,
}

export default AppLayout
